module.exports = __webpack_public_path__ + "img/konfigurasi_cs.2261f10c.svg";